import * as v from 'valibot'

type PlainIntroductionMessageContentFormType = {
  type: 'plain'
  body: string
  selections: string[]
}

type ScenarioChatIntroductionMessageContentFormType = {
  type: 'scenarioChat'
  scenarioChatGuid: string
}

export type IntroductionMessageContentFormType =
  | PlainIntroductionMessageContentFormType
  | ScenarioChatIntroductionMessageContentFormType

export type IntroductionMessageConditionFormType = {
  inflowSourceId: string
}

const validPlainIntroductionMessageContentFormSchema = v.object({
  body: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
  selections: v.pipe(
    v.array(v.string()),
    v.excludes('', '空の選択肢を入力してください')
  ),
})

const validScenarioChatIntroductionMessageContentFormSchema = v.object({
  scenarioChatGuid: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
})

const validIntroductionMessageContentFormSchema = v.union([
  validPlainIntroductionMessageContentFormSchema,
  validScenarioChatIntroductionMessageContentFormSchema,
])

const validIntroductionMessageConditionFormSchema = v.object({
  inflowSourceId: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
})

export const validateIntroductionMessageContentForm = (
  form: IntroductionMessageContentFormType
) => {
  const result = v.safeParse(validIntroductionMessageContentFormSchema, form, {
    abortPipeEarly: true,
  })

  if (result.success) {
    return undefined
  }

  const errors = v.flatten(result.issues).nested
  return form.type === 'plain'
    ? {
        body: errors?.body?.[0],
        selections: errors?.selections?.[0],
      }
    : {
        scenarioChatGuid: errors?.scenarioChatGuid?.[0],
      }
}

export const validateIntroductionMessageConditionForm = (
  form: IntroductionMessageConditionFormType
) => {
  const result = v.safeParse(
    validIntroductionMessageConditionFormSchema,
    form,
    {
      abortPipeEarly: true,
    }
  )

  if (result.success) {
    return undefined
  }

  const errors = v.flatten(result.issues).nested
  return {
    inflowSourceId: errors?.inflowSourceId?.[0],
  }
}
